import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-turns-rules',
  templateUrl: './turns-rules.component.html',
  styleUrls: ['./turns-rules.component.scss']
})
export class TurnsRulesComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
